/* eslint-disable */

import {
    ADD_CART_ITEM_REQUEST,
    ADD_MODAL,
    FETCH_CART_FAILED,
    FETCH_CART_SUCCESS,
    FETCH_NAVITEMS_SUCCESS,
    REMOVE_MODAL
} from "./mutationTypes";

const state = {
    openModals: [],
};

const getters = {
    anyOpen: state => state.openModals.length > 0,
};

const actions = {
    showModal({commit}, {modal}) {
        commit(ADD_MODAL, modal);
    },
    hideModal({commit}, {modal}) {
        commit(REMOVE_MODAL, modal);
    },
};

const mutations = {
    [ADD_MODAL](state, modal) {
        state.openModals.push(modal);
    },
    [REMOVE_MODAL](state, modal) {
        const index =  state.openModals.indexOf(modal);
        if (index > -1) {
            state.openModals.splice(index, 1);
        }
    },
};

export const modal = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};